/* ATELIER theme JS — vanilla, no dependencies.
   Cart uses the native Shopify AJAX Cart API (/cart/add.js etc.).
   A localStorage mirror keeps the header badge instant between pages. */
(function () {
  "use strict";

  var money = function (cents) {
    var v = Math.round(cents / 100);
    return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0") + "\u00a0K\u010d";
  };

  /* ---------------- toast ---------------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      toastEl.setAttribute("role", "status");
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add("is-visible");
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove("is-visible"); }, 2600);
  }

  /* ---------------- cart ---------------- */
  function setCount(n) {
    try { localStorage.setItem("zavernio:cartCount", String(n)); } catch (e) {}
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  // instant paint from mirror, then truth from Shopify
  try { setCount(parseInt(localStorage.getItem("zavernio:cartCount") || "0", 10) || 0); } catch (e) {}
  fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
    setCount(c.item_count);
    renderDrawer(c);
  }).catch(function () {});

  function addToCart(id, qty, redirect) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: Number(id), quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw e; }); }
      return fetch("/cart.js").then(function (r2) { return r2.json(); });
    }).then(function (cart) {
      setCount(cart.item_count);
      renderDrawer(cart);
      if (redirect) { window.location.href = "/checkout"; }
      else { toast("Added to cart"); openDrawer(); }
      return cart;
    }).catch(function (e) {
      toast((e && e.description) || "Could not add to cart");
    });
  }

  function changeLine(line, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      setCount(cart.item_count);
      renderDrawer(cart);
      var page = document.querySelector("[data-cart-page]");
      if (page) window.location.reload();
      return cart;
    });
  }

  /* ---------------- cart drawer ---------------- */
  var drawer = document.querySelector("[data-cart-drawer]");
  function openDrawer() { if (drawer) { drawer.classList.add("is-open"); document.body.style.overflow = "hidden"; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove("is-open"); document.body.style.overflow = ""; } }

  function renderDrawer(cart) {
    if (!drawer) return;
    var body = drawer.querySelector("[data-drawer-items]");
    var totalEl = drawer.querySelector("[data-drawer-total]");
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p style="color:var(--c-grey)">Your cart is empty.</p>';
    } else {
      body.innerHTML = cart.items.map(function (it, i) {
        return '<div class="cart-item" style="margin-bottom:1.2rem">' +
          '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, "_180x180$1$2") : "") + '" alt="" loading="lazy">' +
          '<div style="flex:1">' +
            '<div style="font-size:.8rem;letter-spacing:.1em;text-transform:uppercase;color:var(--c-grey)">' + (it.vendor || "") + "</div>" +
            '<div style="font-weight:600;font-size:.92rem">' + it.product_title + "</div>" +
            '<div style="font-size:.82rem;color:var(--c-slate)">' + (it.variant_title || "") + "</div>" +
            '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:.4rem">' +
              '<div class="qty" style="transform:scale(.85);transform-origin:left">' +
                '<button type="button" data-line-minus="' + (i + 1) + '" aria-label="Decrease">−</button>' +
                '<input value="' + it.quantity + '" readonly aria-label="Quantity">' +
                '<button type="button" data-line-plus="' + (i + 1) + '" aria-label="Increase">+</button>' +
              "</div>" +
              "<strong>" + money(it.final_line_price) + "</strong>" +
            "</div>" +
          "</div></div>";
      }).join("");
    }
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  /* ---------------- delegated clicks ---------------- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;

    var add = e.target.closest("[data-add-to-cart]");
    if (add) {
      e.preventDefault();
      var qtyInput = document.querySelector("[data-qty-input]");
      addToCart(add.getAttribute("data-add-to-cart"),
        qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
        add.hasAttribute("data-buy-now"));
      return;
    }
    if (e.target.closest("[data-open-cart]")) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest("[data-close-cart]")) { closeDrawer(); return; }

    var minus = e.target.closest("[data-line-minus]");
    var plus = e.target.closest("[data-line-plus]");
    if (minus || plus) {
      var el = minus || plus;
      var line = parseInt(el.getAttribute(minus ? "data-line-minus" : "data-line-plus"), 10);
      var input = el.parentElement.querySelector("input");
      var q = parseInt(input.value, 10) + (minus ? -1 : 1);
      changeLine(line, Math.max(0, q));
      return;
    }

    var qtyBtn = e.target.closest("[data-qty-change]");
    if (qtyBtn) {
      var inp = document.querySelector("[data-qty-input]");
      if (inp) inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(qtyBtn.getAttribute("data-qty-change"), 10));
      return;
    }

    if (e.target.closest("[data-menu-toggle]")) {
      var nav = document.querySelector("[data-site-nav]");
      if (nav) nav.classList.toggle("is-open");
      return;
    }
    if (e.target.closest("[data-filter-toggle]")) {
      var f = document.querySelector("[data-facets]");
      if (f) f.classList.toggle("is-open");
      return;
    }

    /* quick view */
    var qv = e.target.closest("[data-quick-view]");
    if (qv) {
      e.preventDefault();
      openQuickView(qv.getAttribute("data-quick-view"));
      return;
    }
    if (e.target.closest("[data-modal-close]")) {
      var m = document.querySelector("[data-quick-modal]");
      if (m) m.classList.remove("is-open");
      return;
    }

    /* gallery thumbs */
    var th = e.target.closest("[data-thumb]");
    if (th) {
      var main = document.querySelector("[data-main-image]");
      if (main) { main.src = th.getAttribute("data-thumb"); main.srcset = ""; }
      document.querySelectorAll("[data-thumb]").forEach(function (b) { b.setAttribute("aria-current", "false"); });
      th.setAttribute("aria-current", "true");
      return;
    }
  });

  /* ---------------- variant / swatch selection (PDP) ---------------- */
  var pdpForm = document.querySelector("[data-product-form]");
  if (pdpForm) {
    var variantData = [];
    var vScript = document.querySelector("[data-variant-json]");
    if (vScript) { try { variantData = JSON.parse(vScript.textContent); } catch (e) {} }
    pdpForm.addEventListener("change", function () { syncVariant(); });
    pdpForm.querySelectorAll(".swatch[data-option-value]").forEach(function (sw) {
      sw.addEventListener("click", function () {
        pdpForm.querySelectorAll(".swatch[data-option-value]").forEach(function (s) { s.setAttribute("aria-pressed", "false"); });
        sw.setAttribute("aria-pressed", "true");
        var hidden = pdpForm.querySelector("[data-option-input]");
        if (hidden) hidden.value = sw.getAttribute("data-option-value");
        var label = document.querySelector("[data-selected-color]");
        if (label) label.textContent = sw.getAttribute("data-option-value");
        syncVariant();
      });
    });
    function syncVariant() {
      var hidden = pdpForm.querySelector("[data-option-input]");
      if (!hidden || !variantData.length) return;
      var match = variantData.find(function (v) { return v.option1 === hidden.value; });
      if (match) {
        pdpForm.querySelectorAll("[data-add-to-cart]").forEach(function (b) { b.setAttribute("data-add-to-cart", match.id); });
        var priceEl = document.querySelector("[data-pdp-price]");
        if (priceEl) priceEl.textContent = money(match.price);
        if (match.featured_image && match.featured_image.src) {
          var main = document.querySelector("[data-main-image]");
          if (main) { main.src = match.featured_image.src; main.srcset = ""; }
        }
        history.replaceState(null, "", "?variant=" + match.id);
      }
    }
  }

  /* ---------------- quick view ---------------- */
  function openQuickView(handle) {
    var modal = document.querySelector("[data-quick-modal]");
    if (!modal) return;
    var box = modal.querySelector("[data-quick-content]");
    box.innerHTML = '<p style="padding:2rem;text-align:center;color:var(--c-grey)">Loading…</p>';
    modal.classList.add("is-open");
    fetch("/products/" + handle + ".js").then(function (r) { return r.json(); }).then(function (p) {
      box.innerHTML =
        '<div class="qv-grid">' +
          '<img src="' + (p.featured_image || "") + '" alt="' + p.title + '">' +
          "<div>" +
            '<div class="card__vendor">' + p.vendor + "</div>" +
            "<h2 style='font-size:1.5rem'>" + p.title + "</h2>" +
            '<div class="price" style="margin-bottom:1rem"><span class="price__current">' + money(p.price) + "</span>" +
            (p.compare_at_price > p.price ? '<s class="price__compare">' + money(p.compare_at_price) + "</s>" : "") + "</div>" +
            '<p style="font-size:.9rem;color:var(--c-slate)">' + (p.description || "").replace(/<[^>]+>/g, " ").slice(0, 220) + "…</p>" +
            '<button class="btn btn--primary btn--full" data-add-to-cart="' + p.variants[0].id + '">Add to cart</button>' +
            '<a class="btn btn--secondary btn--full" style="margin-top:.6rem" href="/products/' + p.handle + '">View full details</a>' +
          "</div></div>";
    }).catch(function () {
      box.innerHTML = '<p style="padding:2rem">Could not load product.</p>';
    });
  }

  /* ---------------- predictive search ---------------- */
  var searchInput = document.querySelector("[data-search-input]");
  if (searchInput) {
    var panel = document.querySelector("[data-predictive]");
    var deb;
    searchInput.addEventListener("input", function () {
      clearTimeout(deb);
      var q = searchInput.value.trim();
      if (q.length < 2) { if (panel) panel.classList.remove("is-open"); return; }
      deb = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6")
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!panel) return;
            panel.innerHTML = items.length ? items.map(function (p) {
              return '<a href="' + p.url + '"><img src="' + (p.image || "") + '" alt="">' +
                '<span><strong style="font-size:.9rem">' + p.title + "</strong><br>" +
                '<span style="font-size:.8rem;color:var(--c-grey)">' + (p.price ? p.price + " K\u010d" : "") + "</span></span></a>";
            }).join("") : '<p style="padding:1rem;font-size:.9rem;color:var(--c-grey)">No results.</p>';
            panel.classList.add("is-open");
          }).catch(function () {});
      }, 220);
    });
    document.addEventListener("click", function (e) {
      if (panel && !e.target.closest(".search-bar")) panel.classList.remove("is-open");
    });
  }

  /* ---------------- collection client-side filters ---------------- */
  var grid = document.querySelector("[data-filter-grid]");
  if (grid) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-card]"));
    function apply() {
      var types = checked("ptype"), colors = checked("colorf");
      var min = num("[data-price-min]"), max = num("[data-price-max]");
      var sort = (document.querySelector("[data-sort]") || {}).value || "featured";
      var visible = cards.filter(function (c) {
        var b = c.getAttribute("data-type"), p = parseFloat(c.getAttribute("data-price"));
        var cl = (c.getAttribute("data-colors") || "").split("|");
        if (types.length && types.indexOf(b) === -1) return false;
        if (colors.length && !colors.some(function (x) { return cl.indexOf(x) !== -1; })) return false;
        if (min !== null && p < min) return false;
        if (max !== null && p > max) return false;
        return true;
      });
      var sorters = {
        "price-asc": function (a, b) { return a.dataset.price - b.dataset.price; },
        "price-desc": function (a, b) { return b.dataset.price - a.dataset.price; },
        "title-asc": function (a, b) { return a.dataset.title.localeCompare(b.dataset.title); },
        "rating": function (a, b) { return b.dataset.rating - a.dataset.rating; }
      };
      if (sorters[sort]) visible.sort(sorters[sort]);
      cards.forEach(function (c) { c.style.display = "none"; });
      visible.forEach(function (c) { c.style.display = ""; grid.appendChild(c); });
      var count = document.querySelector("[data-result-count]");
      if (count) count.textContent = visible.length + " products";
    }
    function checked(name) {
      return Array.prototype.slice.call(document.querySelectorAll('input[data-facet="' + name + '"]:checked'))
        .map(function (i) { return i.value; });
    }
    function num(sel) {
      var el = document.querySelector(sel);
      if (!el || el.value === "") return null;
      return parseFloat(el.value);
    }
    document.addEventListener("change", function (e) {
      if (e.target.matches("[data-facet],[data-sort],[data-price-min],[data-price-max]")) apply();
    });
    document.addEventListener("input", function (e) {
      if (e.target.matches("[data-price-min],[data-price-max]")) apply();
    });
  }

  /* ---------------- newsletter (visual confirm) ---------------- */
  document.querySelectorAll("[data-newsletter]").forEach(function (f) {
    f.addEventListener("submit", function () { toast("Thank you — you're on the list."); });
  });
})();
